import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-097fc702"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns is-centered" }
const _hoisted_2 = { class: "column is-half box" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-097fc702>Cadastro de Tenants</div><div class=\"field\" data-v-097fc702><label for=\"tenant\" class=\"label\" data-v-097fc702>Tenant</label><div class=\"control\" data-v-097fc702><input type=\"text\" class=\"input\" placeholder=\"Tenant\" id=\"tenant\" data-v-097fc702></div></div>", 2)
const _hoisted_5 = { class: "field is-grouped is-grouped-right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "control" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button is-primary",
    type: "submit"
  }, "Salvar")
], -1))
const _hoisted_7 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", null, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/dashboard/tenant",
              class: "button is-light"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancelar")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}